/** @format */

import { Inject, Injectable, Optional } from "@angular/core";
import { Observable, of } from "rxjs";
import { shareReplay, tap } from "rxjs/operators";
import { CONSTANTS_EMPLOYEE_WEB_EXP } from "../constants/emp-web-exp.constants";
import { NsEmployeeWebExp } from "../models/env.model";

@Injectable({
  providedIn: "root"
})
export class EmpUserService {
  employeeInfo = {
    buid: "",
    empGuid: ""
  };
  employeeStream: Observable<NsEmployeeWebExp.IUserInfo>;
  // Passed while injecting data
  environment: NsEmployeeWebExp.IEnv;

  constructor(@Inject(CONSTANTS_EMPLOYEE_WEB_EXP.ENV_VAR) env: NsEmployeeWebExp.IEnv) {
    this.environment = env;
  }

  setUser(buid: string, empGuid: string): void {
    this.employeeInfo = { buid, empGuid };
  }

  getStwId(): string {
    if (this.environment.platform === "ets") return this.splitString(this.employeeInfo.empGuid);
    else return this.employeeInfo.empGuid;
  }

  private splitString(str) {
    const split_string = str.split(/(\d+)/);
    let index = split_string.length - 2;
    let index1 = 0;
    for (let i = 0; i < split_string[index].length; i++) {
      if (split_string[index][i] !== "0") {
        index1 = i;
        break;
      }
    }
    return split_string[index].substr(index1);
  }
  // init(platform: string): void {
  //   if (!platform) {
  //     throw new Error("Missing openedFrom parameter");
  //   }
  //   if (platform === "ios" || platform === "android") {
  //     this.userDetails = {
  //       buid: this.utils.getCookie("buid"),
  //       empGuid: this.utils.getCookie("empGuid"),
  //       officeGuid: this.utils.getCookie("officeGuid"),
  //       openedFrom: platform,
  //     };
  //   }
  // }

  // isInfoAvailable(): boolean {
  //   return !!this.userDetails.buid && !!this.userDetails.empGuid;
  // }

  // closeWebapp(): void {
  //   if (this.userDetails.openedFrom === "ios") {
  //     const data = { params: "goBack" };
  //     if (window["webkit"]) {
  //       window["webkit"].messageHandlers.close.postMessage(data);
  //     }
  //   } else if (this.userDetails.openedFrom === "android") {
  //     if (window["Android"] && window["Android"]["close"]) window["Android"]["close"]();
  //   }
  // }

  showNotification(): void {}
}
